import {
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  onSnapshot,
  setDoc
} from "firebase/firestore";

import { db } from "@/app/providers/Firebase";
import Tour from "@/models/Tour";

const COLLECTION = "tours";

/* ================= UTIL ================= */

function mapDoc<T>(snapshot: any): T {
  return {
    id: snapshot.id,
    ...snapshot.data()
  } as T;
}

/* ================= REPOSITORY ================= */

export const tourRepository = {
  async create(data: Omit<Tour, "id">): Promise<Tour> {
    const ref = doc(collection(db, COLLECTION));

    await setDoc(ref, data);

    return {
      id: ref.id,
      ...data
    };
  },

  async getById(id: string): Promise<Tour | null> {
    const snap = await getDoc(doc(db, COLLECTION, id));

    if (!snap.exists()) return null;

    return mapDoc<Tour>(snap);
  },

  async update(id: string, data: Partial<Tour>) {
    await updateDoc(doc(db, COLLECTION, id), data);
  },

  async delete(id: string) {
    await deleteDoc(doc(db, COLLECTION, id));
  },

  subscribe(
    id: string,
    cb: (tour: Tour | null) => void,
    onError?: (error: Error) => void
  ) {
    return onSnapshot(
      doc(db, COLLECTION, id),
      snap => {
        if (!snap.exists()) {
          cb(null);
        } else {
          cb({
            id: snap.id,
            ...snap.data()
          } as Tour);
        }
      },
      error => onError?.(error)
    );
  },
  subscribeAll(cb: (tours: Tour[]) => void) {
    return onSnapshot(collection(db, COLLECTION), snap => {
      cb(snap.docs.map(d => mapDoc<Tour>(d)));
    });
  }
};
